/*
 * 📱 App | 🌐 Website  — switch between the two admin panels.
 * Shown at the top of both sidebars. Only the owner sees it.
 */
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LAST_WEB = "ycnp_last_web_page";
const LAST_APP = "ycnp_last_app_page";

export default function PanelSwitcher({ compact }) {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const isWeb = pathname === "/website" || pathname.startsWith("/website/");

  const go = (web) => {
    if (web === isWeb) return;
    try {
      localStorage.setItem(isWeb ? LAST_WEB : LAST_APP, pathname);
    } catch (e) {
      /* ignore */
    }
    let to = web ? "/website/overview" : "/dashboard";
    try {
      const saved = localStorage.getItem(web ? LAST_WEB : LAST_APP);
      if (saved && (web ? saved.startsWith("/website/") : !saved.startsWith("/website") && saved !== "/login")) to = saved;
    } catch (e) {
      /* ignore */
    }
    nav(to);
  };

  const item = (web, icon, label, sub) => {
    const on = web === isWeb;
    return (
      <button
        type="button"
        role="tab"
        aria-selected={on}
        onClick={() => go(web)}
        className="relative flex-1 flex items-center justify-center gap-2 rounded-[10px] text-[12.5px] font-bold transition-all"
        style={{
          height: compact ? 34 : 40,
          color: on ? "#0f172a" : "rgba(226,232,240,.75)",
          background: on ? "#fff" : "transparent",
          boxShadow: on ? "0 6px 16px -8px rgba(0,0,0,.6)" : "none",
        }}
        title={sub}
      >
        <i className={icon} style={{ color: on ? (web ? "#0891b2" : "#16a34a") : "inherit" }} />
        <span>{label}</span>
      </button>
    );
  };

  return (
    <div className="mt-3" role="tablist" aria-label="Choose admin panel">
      <div className="flex gap-1 p-1 rounded-xl border border-white/10" style={{ background: "rgba(255,255,255,.06)" }}>
        {item(false, "fa-solid fa-mobile-screen-button", "App", "Android app admin")}
        {item(true, "fa-solid fa-globe", "Website", "ycnp.in website admin")}
      </div>
    </div>
  );
}
